<template>
	<div v-show="value" class="modal">
		<div class="modal-content">
			<div class="title">
				<div class="close" @click="closeButtonClicked">&times;</div>
				{{ title }}
			</div>
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name: 'Modal',
	props: { value: { type: Boolean, required: true }, title: String },
	methods: {
		closeButtonClicked () { this.$emit('input', false); }
	}
}
</script>

<style scoped>
.modal {
  position: fixed;
  z-index: 1;
  top: 0; left: 0; bottom: 0; right: 0;
  background-color: rgba(0, 0, 0, 0.6);
	text-align: left;
}

.modal .modal-content {
  background-color: white;
  border-radius: 8px;
  margin: 20px auto;
	padding: 10px;
	padding-top: 0px;
  border: 1px solid #888;
	box-sizing: border-box;
	max-height: calc(100vh - 40px);
	width: calc(100vw - 40px);
	max-width: 600px;
  overflow: auto;
}

.modal .modal-content .title {
	position: sticky;
	top: 0px;
	padding: 10px 0px;
	font-size: 20px;
	background-color: white;
}

.modal .modal-content .close {
	position: absolute;
	right: 0px; top: 5px;
  color: #aaa;
  font-size: 28px;
  font-weight: bold;
	cursor: pointer;
}

.modal .modal-content .close:hover,
.modal .modal-content .close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>
